import stylesheet from './progress-indicator.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTProgressIndicator extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get icon(): string {
        return this.getAttribute('icon') ?? '';
    }

    get variant(): 'default' | 'text' {
        return (this.getAttribute('variant') ?? 'default') as 'default' | 'text';
    }

    render() {
        const element = document.createElement('div');
        element.classList.add(
            'progress-indicator',
            `style-${this.variant}`,
        );
        element.innerHTML = `
            ${this.icon && `<nxt-icon class="icon" icon="${this.icon}"></nxt-icon>`}
            <div class="label">
                <slot></slot>
            </div>
        `;
        this.cloneDefaultSlotContentIntoContainer(element.querySelector('.label'), false);
        return element;
    }

}

customElements.define('nxt-progress-indicator', NXTProgressIndicator);
